import React from 'react';
import styled from '@emotion/styled';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server'

const Wrapper = styled.header`
  -webkit-clip-path: circle(calc(100%/3) at 50% -10px);
  clip-path: circle(calc(100%/3) at 50% -10px);

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    -webkit-clip-path: circle(50% at 50% 0px);
    clip-path: circle(50% at 50% 0px);
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    -webkit-clip-path: circle(70% at 50% -10px);
    clip-path: circle(70% at 50% -10px);
  }
  background: linear-gradient(to right, #82b1ff 50%, #ff8a80 50%);;

  height: calc(100vw/3.7);
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    height: calc(100vw/2.5);
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    height: 275px;
  }
  position: relative;
  overflow: hidden;
`;

const Subtitle = styled.p`
  max-width: 650px;
  color: ${props => props.theme.colors.white.light};
`;

const Text = styled.div`
  ${'' /* pc */}
  color: ${props => props.theme.colors.white.base};
  z-index: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 0 2rem;
  align-items: center;
  h1 {
    margin-bottom:0;
  }
  width: 40%;
  ${'' /* ipad */}
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    width: 80%;
  ${'' /* phone */}
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    width: 100%;
    }
}`;

const Header = ({ children, title, date }) => (
  <Wrapper>
    <Text>
      <h1>{title}</h1>
      <h3>{date}</h3>
      {children && <Subtitle>{children}</Subtitle>}
    </Text>
  </Wrapper>
);

export default Header;

Header.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.bool,
  ]),
};

Header.defaultProps = {
  children: false,
  date: false,
  title: false,
};
